// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"67":"2072e3e82392ea90","477":"adef0b5f0559f4c8","888":"54a2c3eda8bb1676"}[chunkId] + ".css";
};